/* globals define */
/*
 Purpose:
 - Simple UI controller to update the users name and show hide the login/register buttons

 Dependencies:
 - jQuery
 - Mustache
 - THD Namespace
 */

(function closure(root, factory) {
  /* istanbul ignore else  */
  if (typeof define === 'function' && define.amd) {
    define('header.myaccount', ['jquery', 'mustache', 'header.analytics', 'cookie-utils', 'thd-customer', 'hfConfig', 'plugin.tooltip'],
      function load(jQuery, Mustache, headerAnalytics, cookieUtils, thdcustomer, hfConfig) {
        return factory(root, jQuery, Mustache, headerAnalytics, cookieUtils, thdcustomer, hfConfig);
      });
  } else {
    // For non-AMD module, expose this to global (will also be useful for test cases)
    /*eslint-disable*/
    var _hfapp = THD.Utility.Namespace.createNamespace('THD.HFApp');
    _hfapp.maml = factory(root, jQuery, Mustache, HFApp.analytics, cookieUtils, thdcustomer);
    /*eslint-enable*/
  }
})(this, function factory(root, $, Mustache, headerAnalytics, cookieUtils, thdcustomer, hfConfig) {
  var maml = {};
  var privateMethods = {};
  var nonSecureHostName = hfConfig.nonSecureHostName;
  var secureHostName = hfConfig.secureHostName;

  // determine if the cart is replete with items
  privateMethods.updateAccountIcon = function _updateAccountIcon(username) {
    var userSignedIn = Boolean(username);
    var $accountIcon = $('.MyAccount__icon');

    $accountIcon.find('.HeaderIcon__primary')
      .toggleClass('HeaderIcon__primary--active', userSignedIn);

    $accountIcon.find('.HeaderIcon__secondary')
      .toggleClass('HeaderIcon__secondary--active', userSignedIn);
  };

  privateMethods.isPIPOrCollectionPage = function _isPIPOrCollectionPage() {
    var isPIP = (window.location.href.indexOf('/p/') !== -1);
    var isCollections = (window.location.href.indexOf('/collection/') !== -1);
    return (isPIP || isCollections);
  };


  privateMethods.triggerSignInBubble = function _triggerSignInBubble() {
    $('#triggerSignIn').tooltip({
      type: 'click',
      noPad: true,
      closeOnClick: true,
      width: 'small',
      onOpen: function _onOpenTooltip($tooltip, complete) {
        $('#Header_signInBubble')
          .removeClass('hide')
          .appendTo($tooltip);

        complete();
        cookieUtils.fed_CreateCookie('signInBubble', true, null);
      }
    });
    $('#triggerSignIn').trigger('click');
    setTimeout(function () {
      if (!$('#Header_signInBubble').closest('[id*="tooltip"]').hasClass('ToolTip--closed')) {
        $('#triggerSignIn').trigger('click');
      }
    }, 7000);

  };

  privateMethods.initialize = function initialize() {
    var template = {
      loggedIn: '<div class="MyAccount__userInfo SimpleFlyout__link--bold">Hello, <span class="MyAccount__userInfo__name">{{usersName}}</span></div>',
      loggedInLite: '<span class="MyAccount__userInfo SimpleFlyout__link--bold">Welcome</span>',
      loggedOut: '<div class="MyAccount__label SimpleFlyout__link--bold">My Account</div>'
    };

    privateMethods.usersName = cookieUtils.getTHDUserName();

    privateMethods.updateAccountIcon(privateMethods.usersName);

    privateMethods.determineAuthState(template);

    if (!cookieUtils.hasBrowserCookie("signInBubble") && !Boolean(privateMethods.usersName) && hfConfig.enableSignInBubble === true && hfConfig.currentChannel !== 'mobile') {
      if (privateMethods.isPIPOrCollectionPage()) {
        // Added timeout for PIP/Collection pages as they get reloaded when accessed directly
        setTimeout(function () {
          privateMethods.triggerSignInBubble();
        }, 3000);
      } else {
        privateMethods.triggerSignInBubble();
      }
    }

    if (thdcustomer.isB2XCustomer) {
      thdcustomer.getCustomerData('')
        .then((result) => {
          var res = JSON.parse(result);
          if (res.numberOfServiceAccounts > 1) {
            $('#myaccount-switch-accounts').removeClass('u--hide');
          }
        })
        .catch((err) => {
          // An error occurred
        });
      $('#headerMyAccount').tooltip({
        type: 'click',
        noPad: true,
        closeOnClick: true,
        onOpen: function _onOpenTooltip($tooltip, complete) {
          $('#B2CLinks').remove();
          $('#headerMyAccountDropdown')
            .removeClass('u--hide')
            .appendTo($tooltip);

          complete();

          $(document).trigger('openingHeaderToolTip', 'myaccount');
        }
      });
    } else {
      $('#headerMyAccount').tooltip({
        type: 'click',
        noPad: true,
        closeOnClick: true,
        onOpen: function _onOpenTooltip($tooltip, complete) {
          $('#B2XLinks').remove();
          $('#headerMyAccountDropdown')
            .removeClass('u--hide')
            .appendTo($tooltip);

          complete();

          $(document).trigger('openingHeaderToolTip', 'myaccount');
        }
      });
    }

    // attach event listener to signOut link
    $(document).on('click', 'a#signOut', privateMethods.signOut);

    return privateMethods;
  };

  privateMethods.determineAuthState = function determineAuthState(template) {
    var html;
    if (Boolean(privateMethods.usersName)) {
      if (privateMethods.usersName === 'self') {
        html = template.loggedInLite;
        $('.headerMyAccountTitle').html(html);
      } else {
        // update the name in the button
        html = Mustache.render(template.loggedIn, privateMethods);
        $('.headerMyAccountTitle').html(html);
      }
      // toggle login button state
      if (!$('#SPSOSignIn, #SPSORegister, #authDivider').hasClass('u--hide')) $('#SPSOSignIn, #SPSORegister, #authDivider').addClass('u--hide');
      if ($('#authSignOut').hasClass('u--hide')) $('#authSignOut').removeClass('u--hide');
    } else {
      html = Mustache.render(template.loggedOut, privateMethods);
      $('.headerMyAccountTitle').html(html);
      if ($('#SPSOSignIn, #SPSORegister, #authDivider').hasClass('u--hide')) $('#SPSOSignIn, #SPSORegister, #authDivider').removeClass('u--hide');
      if (!$('#authSignOut').hasClass('u--hide')) $('#authSignOut').addClass('u--hide');
      // update dropdown links only in guest flow
      updateDropdownLinks();
    }

    $('#simpleFlyout .MyAccount__label--loggedout').toggleClass('u--hide', !Boolean(privateMethods.usersName));
    return privateMethods;
  };

  function updateDropdownLinks() {
    try {
      const signInLink = $('#SPSOSignIn').find('a');
      const registerLink = $('#SPSORegister').find('a');
      const { pathname } = document.location;
      if (pathname) {
        signInLink && signInLink.attr('href', `${signInLink.attr('href')}?redirect=${pathname}`);
        registerLink && registerLink.attr('href', `${registerLink.attr('href')}?redirect=${pathname}`);
      }

      $('#headerMyAccountProfile').attr('href', `//${nonSecureHostName}/auth/view/signin?redirect=/account/view/profile`);
      $('#headerInstantCheckoutSettings').attr('href', `//${nonSecureHostName}/auth/view/signin?redirect=/account/view/instantcheckout`);
      $('#headerMyAccountSubscription').attr('href', `//${nonSecureHostName}/auth/view/signin?redirect=/account/view/ordersubscription`);
      $('#headerMyAccountMyList').attr('href', `//${nonSecureHostName}/auth/view/signin?redirect=/list/view/summary`);
      $('#MobiletaskLinkFav').attr('href', `//${nonSecureHostName}/auth/view/signin?redirect=/list/view/summary`);
    } catch (e) {
      console.error(`Updating header myAccount dropdown link error, ${e}`);
    }
  }

  privateMethods.updateUserStatus = function updateUserStatus() {
    privateMethods.initialize();
    // refresh Cart
    $(document).trigger({ type: 'cartUpdated' });

    // refresh store
    $(document).trigger({ type: 'newStoreSet' });
  };

  privateMethods.logStoreFinderInteraction = function _logStoreFinderInteraction() {
    var text = $(this).closest('a').text().toLowerCase();

    return headerAnalytics.logEvent('header click', ['header', 'my account', text].join('>'));
  };

  privateMethods.getSignOutRequest = function getSignOutRequest(url, channelId, Authorization) {
    $.support.cors = true;
    return $.ajax({
      url,
      type: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        channelId,
        Authorization,
      },
      xhrFields: {
        withCredentials: true,
      },
      crossDomain: true,
    });
  };

  privateMethods.signOut = function handleSignOut(event) {
    event.preventDefault();

    /**
     * CustomerAuth service ChannelId
     * 1: Desktop, 2: Mobile
     * @type {number}
     */
    const channelId = hfConfig.currentChannel === 'web' ? 1 : 2;

    const redirectToHomePage = () => window.location.assign(`https://${nonSecureHostName}`);
    const reloadPage = (xhr) => {
      if (xhr && xhr.status === 401) {
        window.location.reload();
      }
    };

    let url;
    let ajax;
    if (thdcustomer.isB2XCustomer) {
      url = `https://${secureHostName}/b2b/user/account/session/logout`;

      ajax = privateMethods.getSignOutRequest(url, channelId)
        .then(redirectToHomePage)
        .fail(reloadPage);
    } else {
      url = `https://${nonSecureHostName}/customer/auth/v1/logout`;
      const authorization = cookieUtils.readBrowserCookie('THD_USER_SESSION');

      ajax = privateMethods.getSignOutRequest(url, channelId, authorization)
        .then(redirectToHomePage)
        .fail(reloadPage);
    }
    return ajax;
  };

  /*
   * Public Methods
   */
  maml.init = function init() {
    $(document)
      .on('click touchend', '#headerMyAccountDropdown .MyAccount__link', privateMethods.logStoreFinderInteraction)
      .on('updateUserStatus', privateMethods.updateUserStatus)
      .ready(privateMethods.initialize);

    return this;
  };

  maml.getPrivateMethods = function getPrivateMethods() {
    return privateMethods;
  };

  return maml;
});
